import { IFileToUpload } from "../../interfaces/IFileToUpload";

export const renameDuplicateNames = (files: IFileToUpload[]) => {
    const updatedFiles = [...files];
    const nameCountMap = new Map();
  
    return updatedFiles.map((file) => {
      const fileFullName: string = `${file.name}.${file.extension}${file.parentFolderId ? file.parentFolderId : ""}`;
      if (nameCountMap.has(fileFullName)) {
        const count = nameCountMap.get(fileFullName);
        nameCountMap.set(fileFullName, count + 1);
        return {
          ...file,
          name: `${file.name} (${(count).toString()})`,
        };
      } else {
        nameCountMap.set(fileFullName, 1);
        return file;
      }
    });
  };